export default defineNuxtPlugin((nuxtApp) => {
  // Dil değiştirildiğinde useAsyncData ile çekilen tüm Strapi verilerini
  // yeni dile göre yeniden getir. fetchApi güncel i18n locale'ini otomatik çözer.
  nuxtApp.hook("i18n:localeSwitched", () => {
    refreshNuxtData()
  })
})
